import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';
import api from '../api/axios';
import { ShieldCheck, ArrowRight, KeyRound, Phone } from 'lucide-react';

export default function SuperAdminLogin() {
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState(1); // ۱: دریافت شماره، ۲: دریافت کد
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/otp/request', { phone });
      setStep(2);
    } catch (err) {
      setError(err.response?.data?.message || 'خطا در ارسال کد');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/auth/otp/verify', { phone, code });
      const { user, token } = res.data.data;

      if (!user.is_super_admin) {
        setError('این شماره حساب کاربری سوپر ادمین ندارد.');
        return;
      }

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      
      // هدایت به صفحه اصلی یا پنل
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'کد وارد شده نامعتبر است');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-wrapper">
      <div className="admin-login-card">
        {/* نشان و آیکون سوپر ادمین */}
        <div className="admin-login-badge">
          {step === 1 ? <ShieldCheck size={34} /> : <KeyRound size={34} />}
        </div>

        <h2 className="admin-login-title">ورود مدیر کل سیستم</h2>
        <p className="admin-login-subtitle">
          {step === 1 
            ? 'جهت دسترسی به پنل مدیریت کل، شماره موبایل خود را وارد کنید' 
            : `کد پیامک‌شده به شماره ${phone} را وارد کنید`}
        </p>

        {error && <div className="admin-login-error">{error}</div>}

        {step === 1 ? (
          <form onSubmit={handleSendOtp} className="admin-login-form">
            <div className="admin-input-group">
              <label>شماره موبایل</label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="09123456789"
                dir="ltr"
                required
                className="admin-input-control"
              />
            </div>
            <button type="submit" disabled={loading} className="admin-btn-primary">
              {loading ? 'در حال ارسال کد...' : 'دریافت کد تأیید'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleVerifyOtp} className="admin-login-form">
            <div className="admin-input-group">
              <label>کد تأیید ۶ رقمی</label>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="123456"
                dir="ltr"
                maxLength={6}
                required
                className="admin-input-control"
                autoFocus
              />
            </div>
            <button type="submit" disabled={loading} className="admin-btn-primary">
              {loading ? 'در حال بررسی...' : 'ورود به پنل'}
            </button>
            <button 
              type="button" 
              onClick={() => { setStep(1); setCode(''); setError(''); }} 
              className="admin-btn-text"
            >
              ویرایش شماره موبایل
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
